import { ResponsiveBar } from "@nivo/bar";

const AppointmentBarChart = () => {
  const data = [
    { month: "Jan", visits: 2 },
    { month: "Feb", visits: 3 },
    { month: "Mar", visits: 1 },
    { month: "Apr", visits: 4 },
  ];

  return (
    <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-100 h-96">
      <h3 className="text-lg font-semibold text-slate-700 mb-4">
        Doctor Visits
      </h3>

      <ResponsiveBar
        data={data}
        keys={["visits"]}
        indexBy="month"
        margin={{ top: 20, right: 20, bottom: 50, left: 50 }}
        padding={0.4}
        borderRadius={6}
        colors={["#0EA5E9"]}
        enableGridX={false}
        theme={{
          axis: {
            ticks: { text: { fill: "#64748B" } },
          },
          grid: { line: { stroke: "#E2E8F0" } },
        }}
      />
    </div>
  );
};

export default AppointmentBarChart;